import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "100px",
      "label-position": "right",
      size: "mini"
    }
  }, [_c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      prop: "type",
      label: "元素类型"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: _vm.form.type === "导入",
      placeholder: "请选择元素类型"
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_c("el-option", {
    attrs: {
      label: "文本",
      value: "文本"
    }
  }), _c("el-option", {
    attrs: {
      label: "表格",
      value: "表格"
    }
  }), _c("el-option", {
    attrs: {
      disabled: "",
      label: "导入",
      value: "导入"
    }
  })], 1)], 1), _c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      prop: "name",
      label: "元素名称"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.form.type === "导入",
      placeholder: "请输入元素名称"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _vm.form.type === "表格" || _vm.form.type === "导入" ? _c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      label: "表格参数"
    }
  }, [_vm.form.type !== "导入" ? _c("el-button", {
    attrs: {
      type: "text"
    },
    on: {
      click: _vm.addHeader
    }
  }, [_vm._v("添加表头")]) : _vm._e(), _c("div", {
    staticClass: "table"
  }, [_c("table", {
    staticClass: ""
  }, [_c("colgroup", _vm._l(_vm.headers, function (header, index) {
    return _c("col", {
      key: index,
      attrs: {
        width: header.width
      }
    });
  }), 0), _c("thead", {
    staticClass: "thead-dark"
  }, [_c("draggable", {
    attrs: {
      tag: "tr"
    },
    model: {
      value: _vm.headers,
      callback: function callback($$v) {
        _vm.headers = $$v;
      },
      expression: "headers"
    }
  }, _vm._l(_vm.headers, function (header, index) {
    return _c("th", {
      key: index,
      attrs: {
        scope: "col"
      }
    }, [_c("div", {
      staticClass: "table-th-wrap"
    }, [_c("el-popover", {
      staticClass: "input-wrap",
      attrs: {
        placement: "top",
        title: "",
        width: "30",
        trigger: "hover"
      }
    }, [_c("div", [_c("div", {
      staticClass: "table-th-wrap"
    }, [_c("el-input-number", {
      staticClass: "input-wrap",
      attrs: {
        placeholder: "表头宽度",
        size: "mini",
        "controls-position": "right",
        min: 15,
        max: 500
      },
      model: {
        value: header.width,
        callback: function callback($$v) {
          _vm.$set(header, "width", $$v);
        },
        expression: "header.width"
      }
    }), _c("el-button", {
      staticClass: "delete-icon",
      attrs: {
        type: "danger",
        size: "mini",
        disabled: _vm.form.type === "导入",
        icon: "el-icon-delete",
        circle: "",
        title: "删除"
      },
      on: {
        click: function click($event) {
          return _vm.remove(index);
        }
      }
    })], 1), _c("div", {
      staticClass: "th-name"
    }, [_vm._v(_vm._s(header.name))])]), _c("el-input", {
      staticClass: "input",
      attrs: {
        slot: "reference",
        disabled: _vm.form.type === "导入",
        size: "mini",
        placeholder: "请输入表头"
      },
      slot: "reference",
      model: {
        value: header.name,
        callback: function callback($$v) {
          _vm.$set(header, "name", $$v);
        },
        expression: "header.name"
      }
    })], 1)], 1)]);
  }), 0)], 1)])])], 1) : _vm._e(), _vm.isInCorrespondence ? [_vm.form.type === "文本" ? _c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      prop: "data",
      label: "元素数据"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入元素数据"
    },
    model: {
      value: _vm.form.data,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data", $$v);
      },
      expression: "form.data"
    }
  })], 1) : _c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      prop: "data",
      label: "元素数据"
    }
  }, [_c("div", {
    staticClass: "table"
  }, [_c("div", {
    staticClass: "table-data-wrap"
  }, [_c("table", {}, [_c("colgroup", _vm._l(_vm.headers, function (header, index) {
    return _c("col", {
      key: index,
      attrs: {
        width: header.width
      }
    });
  }), 0), _c("thead", {
    staticClass: "thead-dark"
  }, [_c("tr", _vm._l(_vm.tableDatas, function (sub) {
    return _c("th", {
      attrs: {
        scope: "col"
      }
    }, [_c("div", {
      staticClass: "table-th-wrap"
    }, [_c("el-input", {
      staticClass: "input",
      attrs: {
        size: "mini",
        placeholder: "请输入数据"
      },
      model: {
        value: sub.val,
        callback: function callback($$v) {
          _vm.$set(sub, "val", $$v);
        },
        expression: "sub.val"
      }
    })], 1)]);
  }), 0)])])])])]), _c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      prop: "account",
      label: "报表科目"
    }
  }, [_c("el-row", {
    attrs: {
      type: "flex",
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      placeholder: "请选择"
    },
    on: {
      change: _vm.typeChange
    },
    model: {
      value: _vm.form.account,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "account", $$v);
      },
      expression: "form.account"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("el-option", {
      key: item.n04Id,
      attrs: {
        label: item.n04Value,
        value: item.n04Value
      }
    });
  }), 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      placeholder: "请输入科目余额"
    },
    model: {
      value: _vm.form.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "amount", $$v);
      },
      expression: "form.amount"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      prop: "perior",
      label: "截止日期"
    }
  }, [_c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择截止日期"
    },
    model: {
      value: _vm.form.perior,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "perior", $$v);
      },
      expression: "form.perior"
    }
  })], 1)] : _vm._e(), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("关闭")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };